export default "__VITE_ASSET__BZYOx7p0__"